import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';
import { GlobalContext } from '../../contexts/GlobalContext';

const ApplicationTaskModal = ({ isOpen, onClose, companyName }) => {
  const { setAddApplicationModalOpen, setRefreshKey, setCurrentApps } =
    useContext(ApplicationTrackerContext);
  const { fetchQuest } = useContext(GlobalContext);

  const handleClose = () => {
    onClose(); // Call the original onClose
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-4">Track your application first!</h2>
        <div className="space-y-4 text-gray-700">
          <p>
            When you add this application to your Application Tracker, this task will automatically
            be marked as done. Trust us, you'll thank yourself later!
          </p>
          <p className="text-sm text-gray-600">
            If you've already added this application to your tracker, the task will be automatically
            completed for you.
          </p>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <Link
            to="/application-tracking"
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Go to Application Tracker
          </Link>
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTaskModal;
